// extracted by mini-css-extract-plugin
module.exports = {"askQuestionTopText":"Hs","yourQuestionLabel":"Is","notAuthedMessage":"Js","form":"Ks","textarea":"Ls","error":"Ms","disabled":"Ns","edited":"Os","submit":"Ps"};